import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as DropdownArrow } from "../../assets/icons/dropdownArrow.svg";
import { toast } from "react-toastify";

interface DropdownProps {
  label: string;
}

const StaticDropdown: React.FC<DropdownProps> = ({ label }) => {
  return (
    <div className="relative">
      <button
        type="button" // Prevent form submission
        className="mt-0 block w-full pl-3 pr-10 py-1 text-left text-base border border-default rounded-lg"
      >
        {/* Display the selected label */}
        <span className="text-secondary text-xs">{label.split("/")?.[0]}</span>
      </button>
    </div>
  );
};

export default StaticDropdown;
